import { createReducer } from '@reduxjs/toolkit';
import { IUser } from '../../models/user.model';
import AuthActions from './action';
import _ from 'lodash';

export interface AuthState {
  user?: IUser | null;
  ready: boolean;
  isAuth: boolean;
}

const initialState = Object.freeze<AuthState>({
  ready: false,
  isAuth: !!localStorage.getItem('access_token'),
});

const authReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(AuthActions.setUser, (state, action) => {
      if (!_.isEqual(state.user, action.payload)) {
        state.user = action.payload;
      }
    })
    .addCase(AuthActions.setReady, (state, action) => {
      state.ready = action.payload;
    })
    .addCase(AuthActions.setAuth, (state, action) => {
      state.isAuth = action.payload;
      state.user = action.payload ? state.user : null;
    });
});

export default authReducer;
